import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const putEditReasonCodeSlice = createApi(`PUTEditReasonCodeSlice`,"PUT");

const PUTEditReasonCodeSlice = createSlice({
  name: 'PUTEditReasonCodeSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putEditReasonCodeSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(putEditReasonCodeSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(putEditReasonCodeSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default PUTEditReasonCodeSlice.reducer;